import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";

import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import SmoothScroll from "@/components/SmoothScroll";
import SpotlightCursor from "@/components/motion/SpotlightCursor";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { trackPageview, startHeartbeat } from "@/lib/tracker";
import { api } from "@/lib/api";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Category from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import MarketingAssets from "@/pages/MarketingAssets";
import Returns from "@/pages/Returns";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import Visitors from "@/pages/admin/Visitors";
import Settings from "@/pages/admin/Settings";

function ScrollAndTrack() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    trackPageview(loc.pathname);
  }, [loc.pathname]);
  useEffect(() => {
    startHeartbeat();
    api.get("/public/config").then(({ data }) => {
      const code = data?.google_site_verification;
      if (code && !document.querySelector('meta[name="google-site-verification"]')) {
        const m = document.createElement("meta");
        m.name = "google-site-verification";
        m.content = code;
        document.head.appendChild(m);
      }
    }).catch(() => {});
  }, []);
  return null;
}

function SiteLayout() {
  return (
    <div className="min-h-screen bg-[#0C0A09]">
      <SmoothScroll />
      <SpotlightCursor />
      <Navbar />
      <CartDrawer />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <ScrollAndTrack />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/about-us" element={<About />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/marketingassets" element={<MarketingAssets />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="orders" element={<Orders />} />
              <Route path="visitors" element={<Visitors />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
